export const fontFaces = `
@font-face {
    font-family: 'Amsterdam';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Amsterdam.woff') format('woff');
}

@font-face {
    font-family: 'ArialSymbols';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://dev.items.rubin.jewelry/fonts/Arial.woff') format('woff');
}

@font-face {
    font-family: 'PalaceScript';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/PalaceScript.woff') format('woff');
}

@font-face {
    font-family: 'AvantGarde';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/AvantGarde.woff') format('woff');
}

@font-face {
    font-family: 'Benguiat';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Benguiat.woff') format('woff');
}

@font-face {
    font-family: 'Berlin';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Berlin.woff') format('woff');
}

@font-face {
    font-family: 'BoereTudor';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/BoereTudor.woff') format('woff');
}

@font-face {
    font-family: 'EdwardianScriptITC';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/EdwardianScriptITC.woff') format('woff');
}

@font-face {
    font-family: 'EnglischeSchT';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/EnglischeSchT.woff') format('woff');
}

@font-face {
    font-family: 'English111VivaceBT';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/English111VivaceBT.woff') format('woff');
}

@font-face {
    font-family: 'FreestyleScript';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/FreestyleScript.woff') format('woff');
}

@font-face {
    font-family: 'Genf';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Genf.woff') format('woff');
}

@font-face {
    font-family: 'Italic';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Italic.woff') format('woff');
}

@font-face {
    font-family: 'Koeln';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Koeln.woff') format('woff');
}

@font-face {
    font-family: 'LegerD';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/LegerD.woff') format('woff');
}

@font-face {
    font-family: 'MonotypeCorsiva';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/MonotypeCorsiva.woff') format('woff');
}

@font-face {
    font-family: 'NuptialBT';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/NuptialBT.woff') format('woff');
}

@font-face {
    font-family: 'Oslo';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Oslo.woff') format('woff');
}

@font-face {
    font-family: 'PalatinoLinotype';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/PalatinoLinotype.woff') format('woff');
}

@font-face {
    font-family: 'Paris';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Paris.woff') format('woff');
}

@font-face {
    font-family: 'ScriptMTBold';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/ScriptMTBold.woff') format('woff');
}

@font-face {
    font-family: 'SloganD';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/SloganD.woff') format('woff');
}

@font-face {
    font-family: 'TimesNewRoman';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/TimesNewRoman.woff') format('woff');
}

@font-face {
    font-family: 'Vivaldi';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('https://items.rubin.jewelry/fonts/Vivaldi.woff') format('woff');
}
`;
